define('controllers/supervisor/member',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/conversation/conversations',
    // services
    'services/user',
    // Contollers
    'src/controller/controller',
    'controllers/modules/calendar/calendar',
    'controllers/modules/goal/goal',
    'controllers/modules/conversation/conversation',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    CConversations,
    // services
    User,
    // controller
    Controller,
    CalendarCtrl,
    GoalCtrl,
    ConversationCtrl
) {

    var SupervisorMemberCtrl = Controller.extend({
        authDefault: true,
        routes: {
            // "*member": "menu",
            "*whatever": "index",
            ":userId(/)*whatever": "index",

            ":userId/graphs(/)": "renderGraphs",
            ":userId/goals(/)": "renderGoals",
            ":userId/messages(/)": "renderMessages",
            ":userId/notes(/)": "renderNotes",
        },

        subRoutes: {
            current: "{{{userId}}}/",
            calendar: "{{{userId}}}/calendar/",
            graph: "{{{userId}}}/graphs/",
            goal: "{{{userId}}}/goals/",
            message: "{{{userId}}}/messages/",
            note: "{{{userId}}}/notes/",
        },

        initialize: function(prefix, opt) {
            opt = opt || {};

            this.role = opt.role;

            var ctrl = this.ctrl = {
                calendar: new CalendarCtrl(
                    this.getPrefix('calendar', { userId: ':userId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.calendar,
                        role: this.role,
                    }),
                goal: new GoalCtrl(
                    this.getPrefix('goal', { userId: ':userId', groupId: ':groupId', goalId: ':goalId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.goal,
                        role: this.role,
                    }),
                conversation: new ConversationCtrl(
                    this.getPrefix('message', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.message,
                        role: this.role
                    }),
            };

            this.listenTo(ctrl.calendar, 'before:route', this.onCalendarRoute);
            this.listenTo(ctrl.goal, 'before:route', this.onGoalRoute);
        },

        ////////////
        // routes //
        ////////////

        /**
         * Default action, redirects to calendar
         * @param  {string} id of the member
         */
        index: function(groupId, userId) {
            var redirectUrl = this.url.calendar;
            if (_.isNull(userId) && User.get('_fallbackMemberId')) {
                userId = User.get('_fallbackMemberId');
                groupId = User.getMainGroupId();
            }

            if (_.isNull(userId) && User.get('isHiddenFromClientsList') && _.isNull(User.get('_fallbackMemberId'))) {
                redirectUrl = "supervisor/group/{{{groupId}}}/noclient/";

                if (User.get('showOnboarding')) {
                    redirectUrl = "supervisor/group/{{{groupId}}}/onboarding/";
                }
            }

            this.navigate(Mustache.render(redirectUrl, {
                groupId: groupId,
                userId: userId ? userId : 'me'
            }), true);
        },

        renderCalendar: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "calendar");
        },

        renderGraphs: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "graph");
        },

        renderGoals: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "goal");
        },

        renderNotes: function(groupId, userId) {
            this.getLayout().showMemberPage(groupId, userId, "note");
        },


        ////////////
        // Events //
        ////////////

        onLayoutSwitch: function(oldLayout, currentLayout) {
            var menu = currentLayout.getMenu().getPrimary();
            currentLayout.showClientMenu();
            menu.findItem('clients').set('active', true);
        },

        onLayoutCreation: function(layout) {
            layout.setUrl('member', _.clone(this.url));
        },

        onCalendarRoute: function(route, params) {
            this.renderCalendar.apply(this, params);
        },

        onGoalRoute: function(route, params) {
            var ctrl = this.ctrl.goal;
            ctrl.index.apply(ctrl, params);
        },

    });

    return SupervisorMemberCtrl;

});

